import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotFound = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 196,
	height: 239,
	viewBox: "0 0 196 239",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M98.3845 60.4725C96.8623 57.2607 93.1296 56.0932 90.0537 57.8665L4.961 106.917C1.88517 108.69 0.623768 112.736 2.14518 115.948L32.7497 180.533C33.5104 182.138 35.3763 182.722 36.9146 181.836L130.367 127.966L98.3845 60.4725Z",
			fill: "#1F51AD"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M98.3845 60.4725C96.8623 57.2607 93.1296 56.0932 90.0537 57.8665L4.961 106.917C1.88517 108.69 0.623768 112.736 2.14518 115.948L32.7497 180.533C33.5104 182.138 35.3763 182.722 36.9146 181.836L130.367 127.966L98.3845 60.4725Z",
			stroke: "#1F51AD",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M102.535 58.0184C101.013 54.8066 97.28 53.6391 94.2042 55.4124L9.19841 104.412C6.12258 106.186 4.86118 110.233 6.38259 113.444L38.3886 180.986L131.754 127.167C133.292 126.28 133.923 124.257 133.162 122.652L102.535 58.0184Z",
			fill: "#7193C2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M102.535 58.0184C101.013 54.8066 97.28 53.6391 94.2042 55.4124L9.19841 104.412C6.12258 106.186 4.86118 110.233 6.38259 113.444L38.3886 180.986L131.754 127.167C133.292 126.28 133.923 124.257 133.162 122.652L102.535 58.0184Z",
			stroke: "#1F51AD",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M100.021 63.8647L13.2265 113.895L39.5228 169.388L126.316 119.356L100.021 63.8647Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M100.021 63.8647L13.2265 113.895L39.5228 169.388L126.316 119.356L100.021 63.8647Z",
			stroke: "#1F51AD",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M39.3755 178.419C39.3755 178.002 39.6532 177.595 40.2296 177.263L132.2 124.248C133.661 123.406 136.491 123.351 138.517 124.126L192.553 144.048C193.778 144.516 194.43 145.182 194.43 145.821V151.911C194.43 152.328 194.152 152.734 193.575 153.067L99.9502 206.191C98.4891 207.033 95.6588 207.087 93.6335 206.313L41.2527 186.282C40.0267 185.813 39.3755 185.148 39.3755 184.509V178.419Z",
			fill: "#B3C8E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M39.3755 178.419C39.3755 178.002 39.6532 177.595 40.2296 177.263L132.2 124.248C133.661 123.406 136.491 123.351 138.517 124.126L192.553 144.048C193.778 144.516 194.43 145.182 194.43 145.821V151.911C194.43 152.328 194.152 152.734 193.575 153.067L99.9502 206.191C98.4891 207.033 95.6588 207.087 93.6335 206.313L41.2527 186.282C40.0267 185.813 39.3755 185.148 39.3755 184.509V178.419Z",
			stroke: "#1F51AD",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M137.584 122.919C136.518 122.511 135.028 122.54 134.259 122.983L39.7812 177.444C39.0124 177.887 39.2531 178.578 40.3197 178.986L96.1764 200.346C97.243 200.753 98.7322 200.725 99.5018 200.281L193.98 145.821C194.749 145.378 194.507 144.687 193.441 144.279L137.584 122.919Z",
			fill: "#D6E3F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M137.584 122.919C136.518 122.511 135.028 122.54 134.259 122.983L39.7812 177.444C39.0124 177.887 39.2531 178.578 40.3197 178.986L96.1764 200.346C97.243 200.753 98.7322 200.725 99.5018 200.281L193.98 145.821C194.749 145.378 194.507 144.687 193.441 144.279L137.584 122.919Z",
			stroke: "#1F51AD",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M141.538 162.078C141.005 161.874 140.259 161.889 139.876 162.111L122.531 172.108C122.147 172.33 122.267 172.676 122.8 172.879L131.691 176.279C132.225 176.483 132.97 176.468 133.354 176.247L150.698 166.249C151.082 166.028 150.963 165.682 150.429 165.478L141.538 162.078Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M141.538 162.078C141.005 161.874 140.259 161.889 139.876 162.111L122.531 172.108C122.147 172.33 122.267 172.676 122.8 172.879L131.691 176.279C132.225 176.483 132.97 176.468 133.354 176.247L150.698 166.249C151.082 166.028 150.963 165.682 150.429 165.478L141.538 162.078Z",
			stroke: "#4A5E87",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M134.491 130.28C133.424 129.872 131.935 129.901 131.166 130.344L54.5075 174.533C53.7387 174.976 53.9802 175.666 55.046 176.074L85.1868 187.6C86.2526 188.008 87.7426 187.979 88.5114 187.535L165.17 143.347C165.938 142.903 165.698 142.213 164.631 141.806L134.491 130.28Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M134.491 130.28C133.424 129.872 131.935 129.901 131.166 130.344L54.5075 174.533C53.7387 174.976 53.9802 175.666 55.046 176.074L85.1868 187.6C86.2526 188.008 87.7427 187.979 88.5114 187.535L165.17 143.347C165.938 142.903 165.698 142.213 164.631 141.806L134.491 130.28Z",
			stroke: "#4A5E87",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M117.558 138.188L68.1156 166.688L102.119 179.692L151.562 151.191L117.558 138.188Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M117.558 138.188L68.1156 166.688L102.119 179.692L151.562 151.191L117.558 138.188Z",
			stroke: "#4A5E87",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M100.665 147.926L85.0089 156.95L119.013 169.954L134.668 160.929L100.665 147.926Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M100.665 147.926L85.0089 156.95L119.013 169.954L134.668 160.929L100.665 147.926Z",
			stroke: "#4A5E87",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M143.734 133.814L64.2896 179.609L75.9433 184.065L155.388 138.271L143.734 133.814Z",
			stroke: "#4A5E87",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.22005 99.2339V36.5373M175.961 111.388V101.58M157.132 66.1519V19.2907M46.9399 59.7091V41.4856M194.814 134.988V38.6633M90.1665 47.6408V1",
			stroke: "#83BAF9",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M141.377 91.6573L148.96 87.0672L143.754 80.2125L143.668 74.7192L136.652 80.5723L140.371 85.0855L131.881 90.0546L127.906 97.9952L134.958 107.031L159.077 95.176V83.0821L163.454 78.6098H152.169V89.4977L144.473 94.0317L141.377 91.6573Z",
			fill: "#D6E3F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M141.377 91.6573L148.96 87.0672L143.754 80.2125L143.668 74.7192L136.652 80.5723L140.371 85.0855L131.881 90.0546L127.906 97.9952L134.958 107.031L159.077 95.176V83.0821L163.454 78.6098H152.169V89.4977L144.473 94.0317L141.377 91.6573Z",
			stroke: "#B3C8E6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M107.442 91.0835C106.315 88.6778 107.362 85.8146 109.778 84.6935L122.911 78.5977C125.326 77.4758 128.203 78.5184 129.329 80.9232L135.452 93.9956C136.579 96.4012 135.532 99.2644 133.116 100.386L119.984 106.481C117.568 107.603 114.693 106.561 113.566 104.156L107.442 91.0835Z",
			fill: "#55A0F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M107.442 91.0835C106.315 88.6778 107.362 85.8146 109.778 84.6935L122.911 78.5977C125.326 77.4758 128.203 78.5184 129.329 80.9232L135.452 93.9956C136.579 96.4012 135.532 99.2644 133.116 100.386L119.984 106.481C117.568 107.603 114.693 106.561 113.566 104.156L107.442 91.0835Z",
			stroke: "#0D78F2",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M114.499 89.3548L118.064 87.7008C121.627 86.0461 123.91 90.9175 120.345 92.5714L116.781 94.2262L117.759 96.3145",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M120.59 99.7234C120.872 100.324 120.611 101.041 120.006 101.321C119.402 101.602 118.683 101.341 118.401 100.74C118.12 100.138 118.381 99.4229 118.986 99.1416C119.59 98.862 120.309 99.1224 120.59 99.7234Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M141.316 103.81C141.316 103.81 128.137 110.487 122.42 113.383C120.912 114.147 119.072 113.743 118.027 112.419C117.991 112.374 117.956 112.329 117.921 112.283C117.254 111.439 117.011 110.338 117.259 109.294C117.508 108.249 118.221 107.374 119.196 106.917C125.606 103.909 137.426 98.3638 137.426 98.3638",
			fill: "#D6E3F5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M141.316 103.81C141.316 103.81 128.137 110.487 122.42 113.383C120.912 114.147 119.072 113.743 118.027 112.419C117.991 112.374 117.956 112.329 117.921 112.283C117.254 111.439 117.011 110.338 117.259 109.294C117.508 108.249 118.221 107.374 119.196 106.917C125.606 103.909 137.426 98.3638 137.426 98.3638",
			stroke: "#B3C8E6",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M126.083 74.4908V67.4077M122.106 74.4908L119.353 71.7502M130.061 74.4908L132.813 71.7502",
			stroke: "#0D78F2",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M98.1679 215.774C119.493 215.774 136.807 220.858 136.807 227.12C136.807 233.382 119.493 238.465 98.1679 238.465C76.8424 238.465 59.5289 233.382 59.5289 227.12C59.5289 220.858 76.8424 215.774 98.1679 215.774Z",
			fill: "#D1D8E0"
		})
	]
});
const ForwardRef = forwardRef(SvgNotFound);
export { ForwardRef as ReactComponent };
